module.exports = ".row{\r\n    PADDING:20PX 0px 10px;\r\n}\r\n.mandatory{\r\n    color:red;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/unify-marketing/unify-marketing-form/unify-marketing-form.component.css
// module id = ./src/app/prospect/unify-marketing/unify-marketing-form/unify-marketing-form.component.css
// module chunks = main